
export const normaliseFilterValueAllToEmptyString = (value) => value === 'ALL' ? '' : value;